var _style, _g, _defs, _ellipse, _polygon, _defs2, _ellipse2, _polygon2, _defs3, _ellipse3, _polygon3, _defs4, _ellipse4, _polygon4, _polygon5, _polygon6, _defs5, _polygon7, _polygon8, _defs6, _polygon9, _polygon10, _polygon11, _polygon12, _g2, _path, _path2, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _line, _polygon21, _path3, _path4, _polygon22, _polygon23, _polygon24, _polygon25, _defs7, _ellipse5, _path5, _line2, _path6, _defs8, _defs9, _ellipse6, _polygon26, _defs10, _defs11, _ellipse7, _defs12, _defs13, _ellipse8, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLincoln1600(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;fill:none;stroke:#808080;stroke-miterlimit:10;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#808080;}\n\t.st4{clip-path:url(#SVGID_4_);fill:#808080;}\n\t.st5{clip-path:url(#SVGID_6_);fill:#808080;}\n\t.st6{clip-path:url(#SVGID_8_);fill:#808080;}\n\t.st7{fill:#CCCCCC;}\n\t.st8{fill:#808080;}\n\t.st9{clip-path:url(#SVGID_10_);fill:#808080;}\n\t.st10{clip-path:url(#SVGID_12_);fill:#808080;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:#4C4C4C;}\n\t.st13{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st14{opacity:0.5;}\n\t.st15{fill:#0AAEFF;}\n\t.st16{clip-path:url(#SVGID_14_);fill:#DEC468;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st18{clip-path:url(#SVGID_16_);}\n\t.st19{clip-path:url(#SVGID_18_);fill:#DEC468;}\n\t.st20{clip-path:url(#SVGID_18_);fill:#CC9527;}\n\t.st21{clip-path:url(#SVGID_20_);}\n\t.st22{clip-path:url(#SVGID_22_);fill:#DEC468;}\n\t.st23{clip-path:url(#SVGID_24_);}\n\t.st24{clip-path:url(#SVGID_26_);fill:#DEC468;}\n\t.st25{fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st26{display:inline;fill:none;stroke:#DB9A00;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 250,
    cy: 250,
    r: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 500,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 500,
    x2: 250,
    y2: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M289.8,403.3c-0.4-7.3-3.3-12.1-7.4-13.2c-2-0.5-13-3.5-15.9-4.3c-2-0.5-4.2-0.2-6.6,1.2 c-7.1,4.2-12.5,16.3-11.9,27.2c0.4,7.3,3.3,12.1,7.4,13.2c2,0.6,13,3.5,15.9,4.3c2,0.6,4.2,0.2,6.6-1.2 C285.1,426.3,290.4,414.1,289.8,403.3z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2563 -0.9666 0.9666 0.2563 -191.1853 573.1946)",
    className: "st3",
    cx: 276.9,
    cy: 410.8,
    rx: 21.5,
    ry: 12.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "294.2,408.7 247.7,396.2 262.3,359.9 308.7,372.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M145.4,364.6c-0.4-7.3-3.3-12.1-7.4-13.2c-2-0.5-13-3.5-15.9-4.3c-2-0.5-4.2-0.2-6.6,1.2 c-7.1,4.2-12.5,16.3-11.9,27.2c0.4,7.3,3.3,12.1,7.4,13.2c2,0.6,13,3.5,15.9,4.3c2,0.6,4.2,0.2,6.6-1.2 C140.6,387.6,145.9,375.4,145.4,364.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2563 -0.9666 0.9666 0.2563 -261.2052 404.7965)",
    className: "st4",
    cx: 132.5,
    cy: 372.1,
    rx: 21.5,
    ry: 12.2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "149.7,370 103.3,357.5 117.8,321.2 164.3,333.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M223.5,319.7c-0.4-7.3-3.3-12.1-7.4-13.2c-2-0.5-13-3.5-15.9-4.3c-2-0.5-4.2-0.2-6.6,1.2 c-7.1,4.2-12.5,16.3-11.9,27.2c0.4,7.3,3.3,12.1,7.4,13.2c2,0.6,13,3.5,15.9,4.3c2,0.6,4.2,0.2,6.6-1.2 C218.7,342.7,224,330.5,223.5,319.7z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible",
      fill: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2563 -0.9666 0.9666 0.2563 -159.7464 446.895)",
    className: "st5",
    cx: 210.5,
    cy: 327.3,
    rx: 21.5,
    ry: 12.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "227.8,325.1 181.4,312.6 195.9,276.3 242.4,288.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M367.6,358.3c-0.4-7.3-3.3-12.1-7.4-13.2c-2-0.5-13-3.5-15.9-4.3c-2-0.5-4.2-0.2-6.6,1.2 c-7.1,4.2-12.5,16.3-11.9,27.2c0.4,7.3,3.3,12.1,7.4,13.2c2,0.6,13,3.5,15.9,4.3c2,0.6,4.2,0.2,6.6-1.2 C362.9,381.3,368.2,369.2,367.6,358.3z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible",
      fill: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2563 -0.9666 0.9666 0.2563 -89.8712 614.9706)",
    className: "st6",
    cx: 354.7,
    cy: 365.9,
    rx: 21.5,
    ry: 12.2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "372,363.7 325.5,351.3 340.1,314.9 386.5,327.4  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "246.7,288.8 264.3,278.6 289.9,285.5 289.9,384 272.3,394.2 246.7,387.3  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "272.3,394.2 272.3,295.7 289.9,285.5 289.9,384  "
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_9_",
    points: "324.7,243.8 342.3,233.6 367.8,240.5 367.8,339 350.2,349.2 324.7,342.3  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible",
      fill: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "350.2,349.2 350.2,250.6 367.8,240.5 367.8,339  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "358.1,256.1 319.9,245.9 319.9,319.4 358.1,329.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_11_",
    points: "180.5,205.2 198.1,195 223.7,201.9 223.7,300.4 206.1,310.5 180.5,303.7  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible",
      fill: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "211.9,218.8 173.8,208.6 173.8,280.6 211.9,290.8  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "206.1,310.5 206.1,212 223.7,201.9 223.7,300.4  "
  }))), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "102.5,250.2 120.1,240 145.7,246.9 145.7,345.4 128.1,355.5 102.5,348.7  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "128.1,355.5 128.1,257 145.7,246.9 145.7,345.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "83,188.7 83,108.5 111.8,91.9 198,114.8 198,195 169.3,211.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "83,108.5 169.3,131.4 169.3,211.6 83,188.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "169.3,131.4 198,114.8 111.8,91.9 83,108.5  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M102.5,220.9l-81.2-21.8c-1.8-0.5-3.3-2.6-3.3-4.6c0-1.2,0.5-2.2,1.4-2.6l66.7-38.5c0.5-0.3,1.2-0.4,2-0.2 l81.2,21.8v7.4L102.5,220.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M102.5,213.5l-81.2-21.8c-1.8-0.5-3.3,0.8-3.3,2.8c0,2,1.5,4.1,3.3,4.6l81.2,21.8V213.5z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "102.5,250.2 102.5,145.5 198.1,90.4 367.8,135.8 367.8,240.5 272.3,295.7  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "102.5,145.5 272.3,191 272.3,295.7 102.5,250.2  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "128.2,200.6 225,226.5 225,246.3 128.2,220.3  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "272.3,191 367.8,135.8 198.1,90.4 102.5,145.5  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "339,257.1 339,176.9 367.8,160.3 477.1,189.6 477.1,269.8 453.4,283.4 425.3,280.2  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "339,176.9 425.3,200 425.3,280.2 339,257.1  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "453.4,203.3 477.1,189.6 367.8,160.3 339,176.9 425.3,200  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "272.3,238.8 339,200.3 339,220.4 272.3,258.9  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 240,
    y1: 182.4,
    x2: 240,
    y2: 287.5
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "339,220.4 315.2,214 339,200.3  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M339,220.4l81.2,21.8c1.8,0.5,3.3,2.6,3.3,4.6c0,1.2-0.5,2.2-1.4,2.6L355.5,288c-0.5,0.3-1.2,0.4-2,0.2 l-81.2-21.8v-7.4L339,220.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M272.3,266.4l81.2,21.8c1.8,0.5,3.3-0.8,3.3-2.8c0-2-1.5-4.1-3.3-4.6l-81.2-21.8V266.4z"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "339,200.3 326.2,217 272.3,248 272.3,238.8  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.3,200 453.4,203.3 453.4,283.4 425.3,280.2  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "430.1,210.7 448.6,212.8 448.6,220.6 430.1,218.5  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "128.2,220.3 151.6,206.8 128.2,200.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M391.2,248.2c0-7.2-14.3-13-31.9-13c-17.6,0-31.9,5.8-31.9,13c0,3.4,0,0,0,3.4c0,7.2,14.3,13,31.9,13 c17.6,0,31.9-5.8,31.9-13C391.2,248.2,391.2,251.6,391.2,248.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible",
      fill: "#CC9527"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 359.3,
    cy: 248.2,
    rx: 31.9,
    ry: 13
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M116.2,193.3l12,27v-19.7l-9.4-9.1C117.5,190.3,115.5,191.7,116.2,193.3z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 117.8,
    y1: 192.6,
    x2: 214.7,
    y2: 218.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M213.3,219.2l11.8,27v-19.7l-9.2-9.1C214.6,216.2,212.6,217.6,213.3,219.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_7"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_15_",
    points: "272.3,238.8 319.5,211.6 360.3,233.6 327.1,264 272.3,254.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M322.9,229.5c0-7.2-14.3-13-31.9-13c-17.6,0-31.9,5.8-31.9,13c0,3.4,0,0,0,3.4c0,7.2,14.3,13,31.9,13 c17.6,0,31.9-5.8,31.9-13C322.9,229.5,322.9,232.9,322.9,229.5z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible",
      fill: "#CC9527"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 291,
    cy: 229.5,
    rx: 31.9,
    ry: 13
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "327.7,195.1 323.4,215.7 269.5,246.8 261,233.6  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_19_",
    points: "58.7,183 76.7,165.7 102.5,165 102.5,206.4 63.6,203  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M136.8,181.5c0-7.2-14.3-13-31.9-13s-31.9,5.8-31.9,13c0,3.4,0,0,0,3.4c0,7.2,14.3,13,31.9,13 s31.9-5.8,31.9-13C136.8,181.5,136.8,184.9,136.8,181.5z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible",
      fill: "#CC9527"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st22",
    cx: 104.9,
    cy: 181.5,
    rx: 31.9,
    ry: 13
  })))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_23_",
    points: "174.4,229.6 217.6,229.1 215.3,223.9 161.6,209.5 157.1,219  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M233,209.6c0-7.2-14.3-13-31.9-13s-31.9,5.8-31.9,13c0,3.4,0,0,0,3.4c0,7.2,14.3,13,31.9,13 s31.9-5.8,31.9-13C233,209.6,233,213,233,209.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible",
      fill: "#CC9527"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 201.1,
    cy: 209.6,
    rx: 31.9,
    ry: 13
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "H",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: -237.6,
    y1: 348.1,
    x2: 486,
    y2: -69.7
  })), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 275.3,
    y1: -127,
    x2: 275.3,
    y2: 628.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: -64.2,
    y1: 447,
    x2: 659.5,
    y2: 29.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 113.4,
    y1: 547.7,
    x2: 837.1,
    y2: 129.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: -107.2,
    y1: 442.3,
    x2: 616.5,
    y2: 24.4
  })), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -1033.2,
    y1: 41.6,
    x2: 961.7,
    y2: 576.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -1017.6,
    y1: 23.8,
    x2: 977.3,
    y2: 558.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -952.8,
    y1: -139.8,
    x2: 1042.1,
    y2: 394.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 125,
    y1: -251.4,
    x2: 125,
    y2: 503.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 147.7,
    y1: -247.6,
    x2: 147.7,
    y2: 507.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 252.7,
    y1: -215.5,
    x2: 252.7,
    y2: 539.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 290.9,
    y1: -236.1,
    x2: 290.9,
    y2: 519.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 344.4,
    y1: -152.4,
    x2: 344.4,
    y2: 602.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 360,
    y1: -261.5,
    x2: 360,
    y2: 493.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 410.9,
    y1: -111.8,
    x2: 410.9,
    y2: 643.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -852.1,
    y1: -80.4,
    x2: 1142.8,
    y2: 454.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -865,
    y1: -176.4,
    x2: 1129.9,
    y2: 358.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 209.6,
    y1: -212.5,
    x2: 209.6,
    y2: 542.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -859.4,
    y1: -3.5,
    x2: 1135.6,
    y2: 531.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -880,
    y1: -158.9,
    x2: 1114.9,
    y2: 375.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: -127.1,
    y1: 433,
    x2: 596.6,
    y2: 15.2
  })), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 435.7,
    y1: -127.3,
    x2: 435.7,
    y2: 627.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: -201.6,
    y1: 406.6,
    x2: 522.1,
    y2: -11.2
  })), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: -928.9,
    y1: 36.3,
    x2: 1066,
    y2: 570.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: -17.3,
    y1: 527.9,
    x2: 706.4,
    y2: 110.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLincoln1600);
export default __webpack_public_path__ + "static/media/lincoln1600.2b7c67f65500dba26a73644e12df5f33.svg";
export { ForwardRef as ReactComponent };